const SET_IDENTIFIER = 'SELECTED_WALL/SET_IDENTIFIER';
const SET_META_DATA = 'SELECTED_WALL/SET_META_DATA';
const SET_PREVIOUS = 'SELECTED_WALL/SET_PREVIOUS';
const SET_PROPERTIES = 'SELECTED_WALL/SET_PROPERTIES';
const SET_RAW = 'SELECTED_WALL/SET_RAW';

export { SET_IDENTIFIER, SET_META_DATA, SET_PREVIOUS, SET_PROPERTIES, SET_RAW };
